import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CA2546B9-70B0-4E1A-B646-17163B0C76E4
 * name call-missed
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/call-missed.svg
 * tags
 * - Cellphone / Phone 
 * - Arrow 
 */
export const CallMissedIcon = createSvgIcon(<><path d="M19.59,7L12,14.59L6.41,9H11V7H3V15H5V10.41L12,17.41L21,8.41" /></>, 'CallMissedIcon');
export default CallMissedIcon